import React from "react";

const EmptyCartIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="107"
        height="107"
        fill="none"
      >
        <path
          fill="url(#empty-cart_svg__a)"
          d="M94.313 0c-4.724 0-8.796 3.19-9.903 7.754l-2.763 11.405h-71.14c-3.146 0-6.066 1.41-8.009 3.87a10.015 10.015 0 0 0-1.888 8.65l8.367 34.175c1.113 4.552 5.184 7.73 9.896 7.73h45.552c4.712 0 8.783-3.178 9.896-7.73l2.918-11.912.053-.216 8.463-34.565h-.087l2.543-10.496a6.251 6.251 0 0 1 6.102-4.778h12.004V.002H94.313V0Zm-23.79 64.933a6.254 6.254 0 0 1-6.098 4.764H18.873a6.253 6.253 0 0 1-6.099-4.764L4.408 30.76a6.175 6.175 0 0 1 1.164-5.332 6.255 6.255 0 0 1 4.936-2.384h70.198L75.524 44.43H24.467v3.885h50.115l-1.144 4.716-2.914 11.905v-.002Z"
        ></path>
        <path
          fill="url(#empty-cart_svg__b)"
          d="M67.678 78.64c-5.925 0-10.744 4.792-10.744 10.68 0 5.889 4.82 10.68 10.744 10.68 5.924 0 10.744-4.791 10.744-10.68 0-5.888-4.82-10.68-10.744-10.68Zm0 17.477c-3.77 0-6.835-3.05-6.835-6.795 0-3.746 3.067-6.795 6.835-6.795 3.769 0 6.836 3.05 6.836 6.795 0 3.746-3.067 6.795-6.836 6.795Z"
        ></path>
        <path
          fill="url(#empty-cart_svg__c)"
          d="M15.621 78.64c-5.925 0-10.744 4.792-10.744 10.68 0 5.889 4.82 10.68 10.744 10.68 5.924 0 10.744-4.791 10.744-10.68 0-5.888-4.82-10.68-10.744-10.68Zm0 17.477c-3.77 0-6.835-3.05-6.835-6.795 0-3.746 3.067-6.795 6.835-6.795 3.769 0 6.836 3.05 6.836 6.795 0 3.746-3.067 6.795-6.836 6.795Z"
        ></path>
        <defs>
          <linearGradient
            id="empty-cart_svg__a"
            x1="73.662"
            x2="52.656"
            y1="0"
            y2="78.829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B1B1B1"></stop>
            <stop offset="1" stopColor="#c4c4c4"></stop>
          </linearGradient>
          <linearGradient
            id="empty-cart_svg__b"
            x1="71.802"
            x2="63.64"
            y1="78.641"
            y2="100.033"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B1B1B1"></stop>
            <stop offset="1" stopColor="#c4c4c4"></stop>
          </linearGradient>
          <linearGradient
            id="empty-cart_svg__c"
            x1="19.745"
            x2="11.583"
            y1="78.641"
            y2="100.033"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B1B1B1"></stop>
            <stop offset="1" stopColor="#c4c4c4"></stop>
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default EmptyCartIcon;
